import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";

function LoadingScreen({ label }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-[#FBFBF9]"
      data-testid="loading-screen"
    >
      <div className="h-8 w-8 rounded-full border-2 border-[#1E3A2B]/20 border-t-[#1E3A2B] animate-spin" />
      <p className="mt-4 font-mono-label text-[11px] text-[#5B655F]">{label}</p>
    </div>
  );
}

export default function ProtectedRoute({ children, allow }) {
  const { user, loading } = useAuth();
  const { t } = useLanguage();

  if (loading) return <LoadingScreen label={t("common.loading")} />;
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

export { LoadingScreen };
